'use client';

import { motion } from 'framer-motion';
import { HandleClick } from 'next-bricks';

import { Icon, IconName } from 'components/Icon';
import Link from 'components/Link';
import { HEADER_NAVIGATION_LINKS, social } from 'constants/institutional';
import { toEntries } from 'utils/toOptions';
import HeaderButtons from '../HeaderButtons';

import styles from './styles.module.css';

interface MobileMenuProps {
	onClose: () => void;
}

function MobileMenu(props: MobileMenuProps) {
	return (
		<motion.div
			className={styles.container}
			initial={{
				y: '100%',
				transformPerspective: 1000,
				opacity: 0,
				rotateX: -42,
				scaleY: 0.8,
				transformOrigin: 'top',
			}}
			animate={{
				y: '100%',
				transformPerspective: 1000,
				opacity: 1,
				rotateX: 0,
				scaleY: 1,
			}}
			exit={{
				y: '100%',
				transformPerspective: 1000,
				opacity: 0,
				rotateX: -42,
				scaleY: 0.8,
			}}
			transition={{
				duration: 0.3,
			}}
		>
			<div className={styles.buttons}>
				<HeaderButtons isMobile />
			</div>

			<div className={styles.divider} />

			<nav>
				<ul>
					{HEADER_NAVIGATION_LINKS.map((link) => (
						<li key={link.label}>
							<Link<string> to={link.to}>
								{link.label}

								<Icon name="ArrowUpRight" size={24} />
							</Link>
						</li>
					))}
				</ul>
			</nav>

			<div className={styles.divider} />

			<nav>
				<ul>
					{toEntries(social).map((item) => {
						const iconMap = {
							instagram: 'Instagram',
							whatsapp: 'Whatsapp',
							x: 'TwitterX',
						} satisfies Record<keyof typeof social, IconName>;

						return (
							<li key={item.key}>
								<a
									href={item.value}
									rel="noreferrer noopenner"
									target="_blank"
									aria-label="Conheça nosso perfil no Instagram"
								>
									{iconMap[item.key]}

									<Icon name={iconMap[item.key]} size={20} />
								</a>
							</li>
						);
					})}
				</ul>
			</nav>

			<HandleClick selectors={['li a']} onClick={props.onClose} />
		</motion.div>
	);
}

export default MobileMenu;
